import axiosInstance from "../server/axios";
import { toast } from 'react-toastify';

export const registerApi = async (username, email, password, navigate) => {
  try {
    const response = await axiosInstance.post('/register', { username, email, password });

    if (response.data.requires_verification) {
      return {
        requiresTwoFactor: true,
        email: response.data.email,
        message: response.data.message
      };
    }

    const { token, user } = response.data;
    localStorage.setItem('authToken', token);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('role', user.roles?.[0]?.name || 'client');

    return user;
  } catch (error) {
    toast.error('Registration failed');
    throw error;
  }
};